module.exports = __webpack_public_path__ + "img/next_arrow_gray.d70897d9.svg";